<script>
import JobCard from './JobCard'

export default {
  name: 'PageJobs',

  components: {
    JobCard
  },

  data() {
    return {
      jobs: null
    }
  },

  created() {
    this.Loading.yes = true

    this.axios.get('/jobs')
      .then(this.feed.bind(this))
      .finally(() => (this.Loading.yes = false))
  },

  methods: {
    loadMore() {
      if (this.jobs && this.jobs.next_page_url && !this.Loading.yes) {
        this.axios.get(this.jobs.next_page_url)
          .then(this.feed.bind(this))
          .finally(() => (this.Loading.yes = false))
      }
    },

    feed(response) {
      if (this.jobs) {
        const old_data = this.jobs.data

        this.jobs = response.data
        this.jobs.data = old_data.concat(this.jobs.data)
      } else {
        this.jobs = response.data
      }
    }
  }
}
</script>

<template>
  <section class="container">
    <div v-if="jobs && jobs.total">
      <h1 class="title is-3">({{ jobs.total }}) emplois</h1>

      <job-card
        class="job"
        v-for="job in jobs.data"
        :key="job.id"
        :job="job"/>

      <button
        class="button is-primary"
        @click="loadMore">
        Voir plus
      </button>
    </div>
    <p class="notification is-light"
      v-if="jobs && !jobs.total">
      Rien à voir par ici...
    </p>
  </section>
</template>

<style scoped>
.container {
  max-width: 720px;
}

.job {
  margin-bottom: 10px;
}

h1 {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/PageJobs.vue